module.exports = __webpack_public_path__ + "static/media/creditcard_01.85f5080f.svg";